import type { MyBet } from '@ps/isp-web-services-types';

export function getIsFutureOrInPlay(inPlay: boolean, startTime: string | undefined) {
  return inPlay || (startTime ? new Date(startTime) > new Date() : false);
}

export function getFutureOrInPlayLeg(bet: MyBet): boolean {
  return bet.legs.some((leg) =>
    leg.parts.find((part) => getIsFutureOrInPlay(part.inPlay, part.startTime))
  );
}
